import { gql } from 'react-apollo';

export default gql`
  mutation wefunderOfferRequestInformation(
    $offerId: ID!
    $message: String
    $investorWefunderId: ID
  ) {
    wefunderOfferRequestInformation(
      offerId: $offerId
      message: $message
      investorWefunderId: $investorWefunderId
    )
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/mutations/wefunderOfferRequestInformation.js